import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await register(form.email, form.password, form.name);
      toast.success("Welcome to IPVALUE!");
      nav("/account");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="register-page">
      <div className="ipv-eyebrow text-[#0A1C40]">New customer</div>
      <h1 className="font-display font-black text-4xl tracking-tighter mt-3">Create an account</h1>
      <form onSubmit={onSubmit} className="mt-8 space-y-4">
        <input required placeholder="Full name" className="input-base" value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name" />
        <input required type="email" placeholder="Email" className="input-base" value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" />
        <input required type="password" placeholder="Password (min 6)" className="input-base" value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" />
        <button type="submit" disabled={submitting} className="btn-primary w-full" data-testid="register-submit-btn">
          {submitting ? "Creating…" : "Create account"}
        </button>
      </form>
      <div className="text-sm text-gray-600 mt-6">
        Already have an account?{" "}
        <Link to="/login" className="text-[#0A1C40] font-bold hover:underline">
          Sign in
        </Link>
      </div>
    </div>
  );
}
